export default {
    message: {
        impersonation: "Vous commandez au nom de «{name}»"
    }
}